// Compact ads-runner checkbox for Admin → Active Members (SC-2).

import { adminAdsRunnerCheckboxValue } from "@/lib/capabilities/capabilityMerge";
import type { CapabilityOverrides } from "@/lib/capabilities/capabilityOverrides";
import { cardMutedTextClass } from "@/components/common/surfaceClasses";
import type { MemberWithProfile } from "./adminTypes";

export type AdminMemberAdsRunnerCheckboxProps = {
  member: MemberWithProfile;
  dbGrants: CapabilityOverrides | undefined;
  disabled?: boolean;
  onChange: (member: MemberWithProfile, value: boolean) => void;
};

export function AdminMemberAdsRunnerCheckbox({
  member,
  dbGrants,
  disabled = false,
  onChange,
}: AdminMemberAdsRunnerCheckboxProps) {
  const checked = adminAdsRunnerCheckboxValue({
    dbGrant: dbGrants?.is_ads_runner,
    memberRoles: member.roles,
  });
  const hasExplicitGrant = dbGrants?.is_ads_runner !== undefined;

  return (
    <label className={`inline-flex items-center gap-2 text-sm ${cardMutedTextClass}`}>
      <input
        type="checkbox"
        className="rounded border-gray-300"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(member, e.target.checked)}
      />
      <span>
        Ads runner
        {hasExplicitGrant ? (
          <span className="ml-1 text-[10px] uppercase tracking-wider text-gray-400">admin set</span>
        ) : (
          <span className="ml-1 text-[10px] uppercase tracking-wider text-gray-400">role default</span>
        )}
      </span>
    </label>
  );
}
